import React from 'react'
import { Breadcrumbs, Grid, Link, Typography } from '@mui/material'
import Exercise from './Exercise'
import Header from '../Header'
import { useLocation } from 'react-router-dom';


function ExercisePage() {
    const location = useLocation();
    // console.log(location);
    const {  exercise } = location.state;
    console.log(exercise,'exercise=============')

    return (
        <>
            <Header />
            <div className='full-container'>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit"
                        onClick={() => {}}
                    >
                        Home
                    </Link>
                    <Typography color="text.primary">{`Exercise`}</Typography>
                </Breadcrumbs>
                <div style={{ marginTop: '20px' }}>
                    <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
                        {exercise && exercise.length > 0 && exercise.map((exercise, index) => {
                            return <Exercise key={index} exercise={exercise} />
                        })
                        }
                    </Grid>
                </div>
            </div>
        </>

    )
}

export default ExercisePage